module.exports = __webpack_public_path__ + "img/08_DSC7755.61fa95ae.jpg";